export default __webpack_public_path__ + "static/media/logo_entryfish_white.b84e91ec.png";